import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { connect } from 'react-redux';
import axios from '../../axios';
import { toolkitCategories, initialToolDetailsState } from '../../utils/categories';
import {filterToolFocus} from '../../utils/filterToolData';
import  { socketConnection }  from './../../socketClient';
import * as actionCreators from '../../modules/actions/index';
import * as url from '../../utils/url';
import {deepClone} from './../../utils/copyObject';
import {addToolStep, toolkitSteps,create_event_hosts, eventRoles, groupRoles,calculateStyles, rsvpRoles} from '../../utils/constants';
import {addToolDetailsInForm} from '../../utils/createRequestData';
import Steps from '../../components/Steps/Steps';
import LocationAndContact from "./Components/LocationAndContact/LocationAndContact";
import Info from './Components/Info/Info';
import Focus from './Components/Focus/Focus';
import PrivacySettings from './Components/PrivacySettings/PrivacySettings';
import ErrorMessage from '../../components/Message/ErrorMessage/ErrorMessage';
import Loading from '../../hoc/Loading/Loading';
import "./Toolkit.css";

class AddToolkit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      diversityFocusOptions: [],
      relevantForOptions: [],
      error: false,
      errorMessage: ''
    }
  }

  componentWillReceiveProps(nextProps) {
     const category = this.props.match.params.category;
     if (nextProps.toolDetails.nextStep === addToolStep.preview) {
        this.props.history.replace(`/home/toolkit/${category}/preview`);
     } 
  }

  componentWillMount() {
    console.log('page will unmount')
  }

  // componentWillUnmount

  componentDidMount() {
    const location = this.props.history.location;
    const category = this.props.match.params.category;
    let {toolDetails} = this.props;
    // this.props.onLeaveAddTool();    

    let {groupEvent}=this.props.user
    const unblock = this.props.history.block((location, action) => {
      console.log(location.pathname)
      if (!location.pathname.startsWith(`/home/toolkit/${category}/tool`) && location.pathname!==`/home/toolkit/${category}/preview` 
          && (groupEvent&& groupEvent.groupId&&!location.pathname.startsWith(`/home/groups/${this.props.user.organizationId._id}/view/${groupEvent.groupId}/events`)))
        {
          return "You have not completed the process yet. Are you sure you want to leave without completing it?";
        }  
      if (action==='POP') return "You have not completed the process yet. Are you sure you want to leave without completing it?";
    }); 

    const unlisten = this.props.history.listen((location, action) => {
      console.log(location.pathname)
        if(location.pathname!=`/home/toolkit/${category}/add` && !location.pathname.startsWith(`/home/toolkit/${category}/edit`)
         && location.pathname!=`/home/toolkit/${category}/preview`
         && 
         (groupEvent&& groupEvent.groupId&&!location.pathname.startsWith(`/home/groups/${this.props.user.organizationId._id}/view/${groupEvent.groupId}/events`) )
         ) {
          unlisten();
          unblock();
          let result={ groupEvent: null }
          this.props.onProfileUpdate(result);
          this.props.onLeaveAddTool();
        }
      }); 


let eventType = {category:toolkitCategories.filter(e=>e.link=='conferences-events')[0].name}


    if (!toolDetails || !toolDetails.category || !toolDetails.category === "" || !toolDetails.category) {
      if ((this.props.location.state && this.props.location.state.category) || (groupEvent && groupEvent.groupId)) {
        let toolDetails = groupEvent && groupEvent.groupId? eventType: this.props.location.state;
        toolDetails.nextStep = addToolStep.info;
        toolDetails.category = this.props.location.state.category
        toolDetails.currentStep =1
        toolDetails.relevantFor=[]
        toolDetails.diversityFocus=[]
        this.props.onChooseCategory({ ...deepClone(initialToolDetailsState), ...toolDetails});
      }
    }
    if((this.props.location && this.props.location.state && this.props.location.state.category) || (groupEvent && groupEvent.groupId)){
      toolDetails.category = groupEvent && groupEvent.groupId? eventType.category: this.props.location.state.category
      toolDetails.relevantFor=[]
        toolDetails.diversityFocus=[] 
    }
    
    this.getToolFocusOptions();
  }

  getToolFocusOptions = () => {
    axios.get(url.getAllFoucsList).then(response => {
      // console.log(response)
      let { diversityFocusOptions, relevantForOptions } = filterToolFocus(response.data);
      console.log('diversityFocusOptions --- ', diversityFocusOptions)
      this.setState({ diversityFocusOptions, relevantForOptions });
    }).catch(error => {
      console.log(error);
    });
  }
  
  handleToolInfoCompleted = (info) => {
     this.props.onToolInfoCompleted({nextStep: addToolStep.focus, ...info});
  };

  handleToolFocusCompleted = (focus) => {
    this.props.onToolFocusCompleted({nextStep: addToolStep.locationAndContact, ...focus});
  };

  handleToolLocationAndContactCompleted = (locationAndContact) => {
    console.log(locationAndContact)
    this.props.onToolLocationAndContactCompleted({nextStep: addToolStep.privacy, ...locationAndContact});
  };

  handleToolPrivacySettingsCompleted = (privacy) => {
    this.props.onToolPrivacySettingsCompleted({nextStep: addToolStep.privacy, ...privacy});
    this.handleCreateTool({...this.props.toolDetails, ...privacy});
  };

  handleToolShowPreviewTool = (privacy) => {
    this.props.onToolPrivacySettingsCompleted({nextStep: addToolStep.preview, ...privacy});
  };

  handleCreateTool = (toolDetails) => {
    // console.log("aaaaaaaaaaaaa",toolDetails)
    // delete toolDetails._id;
    let formData = new FormData();

    console.log('toolDetails 140 --- ', toolDetails)


    if(toolDetails.category==="Programs & Initiatives"){
      toolDetails.category = 'Programs & Initiatives'
    }

    let{user}=this.props, {groupEvent}=user
    let groupUrl=null
    
    
    if(groupEvent&&groupEvent.groupId){
      groupUrl = `/home/groups/${user.organizationId._id}/view/${groupEvent.groupId}/events`
      toolDetails = {...toolDetails, groupId: groupEvent.groupId}
    }

    if((!toolDetails.hasOwnProperty('_id') || toolDetails.hasOwnProperty('_id')==null) && toolDetails.category==='Conferences & Events'){

      let event_owner = create_event_hosts(user, user,toolDetails, groupEvent )
        let{invitees}= toolDetails
        toolDetails = {...toolDetails, invitees:[...invitees,event_owner ]}
    } 



    if(toolDetails&& toolDetails.invitedUsers && toolDetails.invitedUsers.length>0 &&  toolDetails.category==='Conferences & Events'){
      let{invitedUsers}=toolDetails
        let host_arr = invitedUsers.map(host=> {
          host={...host, _id: host.value}
          console.log('host---- ', host)
          return create_event_hosts(user, host, toolDetails, groupEvent )
        })
        let{invitees}= toolDetails

      toolDetails = {...toolDetails, invitees:[...invitees, ...host_arr ]}
    }

    formData.append('payload', JSON.stringify(toolDetails))


    if(toolDetails.attachments && toolDetails.attachments.length>0){
      Array.from(toolDetails.attachments).forEach(itm => {
        formData.append('attachments', itm.file);
      })
    }


  if(toolDetails.bannerImg && toolDetails.bannerImg.file && toolDetails.bannerImg.isUploaded ){
    Array.from([toolDetails.bannerImg]).forEach(itm => {
      formData.append('bannerImg', itm.file);
    })
  }
  
    formData = addToolDetailsInForm(formData, toolDetails);
    axios.post(url.addTool, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const category = this.props.match.params.category;
      let resolveUrl
      if(groupUrl){
        resolveUrl = groupUrl
      } else {
        resolveUrl = `/home/toolkit/${category}/tool/${response.data._id}`
      }

      // this.props.history.replace(resolveUrl);

      this.props.history.push(resolveUrl)

      // Socket call for Saving ToolName and Tool Category.
      // socketConnection.track("Add_Toolkit_Click", {
      //   toolName : toolDetails.name,
      //   toolCategory : toolDetails.category
      // });

      this.props.onAddToolSuccess({...initialToolDetailsState, category: this.props.toolDetails.category, isPrivacySettingsChanged: false});
    }).catch(error => {
       console.log(error);
       this.setState({error: true, errorMessage: 'Failed to add tool. Please try again.'});
    });
  }

  handleGoBack = () => {
    let previousStep = '';
    if(this.props.toolDetails.nextStep === addToolStep.focus) {
       previousStep = addToolStep.info;
      } else if(this.props.toolDetails.nextStep === addToolStep.locationAndContact) {
       previousStep = addToolStep.focus;
      } else if(this.props.toolDetails.nextStep === addToolStep.privacy) {
       previousStep = addToolStep.locationAndContact;
      }
    this.props.onGoBackPressed({nextStep: previousStep});
  }

  navigateToChooseCategory = () => {
    this.props.history.replace('/home/toolkit/choose-category');
  }


  backToGroup=()=>{
    let{groupEvent}=this.props.user
    this.props.history.push(`/home/groups/${this.props.user.organizationId._id}/view/${groupEvent.groupId}`)
  }


  render() {
    // console.log(this.state, this.props)
    let {toolDetails} = {...this.props} || this.props.location.state
    let {error, errorMessage, diversityFocusOptions, relevantForOptions} = {...this.state};
    let addToolCurrentStep = null;
    let currentToolStep = 0;
    let errorMessageView = null;
   

    if(error) {
      errorMessageView = <ErrorMessage message={errorMessage}/>
    } 

    if(!toolDetails){
      if(this.props.location && this.props.location.state && this.props.location.state.category){
      toolDetails.category = this.props.location.state.category
      }
    }
   


    if(toolDetails.nextStep === addToolStep.info || toolDetails.nextStep==="" || !toolDetails ) {
      currentToolStep = 1;
      addToolCurrentStep = <Info onCompleted={this.handleToolInfoCompleted} goBackToPreviousStep={this.handleGoBack} toolDetails={this.props.toolDetails}/> 
    } else if(toolDetails.nextStep === addToolStep.focus) {
      currentToolStep = 2;
      addToolCurrentStep = <Focus onCompleted={this.handleToolFocusCompleted} goBackToPreviousStep={this.handleGoBack} diversityFocusOptions={diversityFocusOptions} relevantForOptions={relevantForOptions} {...this.props} />
    } else if(toolDetails.nextStep === addToolStep.locationAndContact) {
      addToolCurrentStep = <LocationAndContact onCompleted={this.handleToolLocationAndContactCompleted} goBackToPreviousStep={this.handleGoBack} {...this.props}/> 
      currentToolStep = 3;
    } else if(toolDetails.nextStep === addToolStep.privacy) {
      currentToolStep = 4;  
      addToolCurrentStep = <PrivacySettings onCompleted={this.handleToolPrivacySettingsCompleted} showPreviewTool={this.handleToolShowPreviewTool} goBackToPreviousStep={this.handleGoBack} {...this.props}/> 
    }

    let{groupEvent}=this.props.user

    return (
      <div className="edit_toolkit_page_container col-md-11 col-sm-11 col-lg-11">
      {/* // style={ calculateStyles(['width','backgroundColor'], 'add-tool' ) } */}
      {/* > */}
        <div>
          <Breadcrumb>
            {/* <BreadcrumbItem> */}

            { groupEvent && groupEvent.groupId && groupEvent.name?
                <span className="grp_add_event_link_header">
                  Add Event in <span className="grp_add_event_link_header_name" onClick={this.backToGroup}>{groupEvent.name}</span>
                </span>
            :
            <span>
                  <BreadcrumbItem>
                    <a className="add-tool-link" onClick={this.navigateToChooseCategory}>Add resource</a>
                  </BreadcrumbItem>
                  <BreadcrumbItem active><span className="create-chart-active-category">{toolDetails.category}</span></BreadcrumbItem>
            </span>
            }

          
          </Breadcrumb>
        </div>
        {/* <div className="add-category-title">Add {toolDetails.category}</div> */}
        <Steps steps={toolkitSteps} currentStep={currentToolStep}/>
        {errorMessageView}
        {addToolCurrentStep}
      </div>
    );
  }
}

const mapStateToProps = state => {
	return {
    toolDetails : state.toolkit.toolDetails,
    user: state.user.profile
	}
}
const mapDispatchToProps = dispatch => {
	return {
    onChooseCategory: data => dispatch(actionCreators.addToolChooseCategorySuccess(data)),
    onToolInfoCompleted: (data) => dispatch(actionCreators.toolInfoCompleted(data)),
    onToolFocusCompleted: (data) => dispatch(actionCreators.toolFocusCompleted(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
    onToolLocationAndContactCompleted: (data) => dispatch(actionCreators.toolLocationAndContactCompleted(data)),
    onToolPrivacySettingsCompleted: (data) => dispatch(actionCreators.toolPrivacySettingsCompleted(data)),
    onGoBackPressed: (data) => dispatch(actionCreators.toolGoBackPressed(data)),
    onAddToolSuccess: (data) => dispatch(actionCreators.addToolSuccess(data)),
    onLeaveAddTool: () => dispatch(actionCreators.leaveAddTool())
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Loading(AddToolkit, axios));
